import { AutomationEventTypes } from '@tokeet-frontend/automations'

export const userTaskNotificationMessages = {
  [AutomationEventTypes.TaskCreated]: {
    subject: 'New Task is created for you at *|RENTAL:NAME|*',
    message: `
      Hi Team,

      A new task has been created for you. Please see the details below:

      Task Name: *|TASK:NAME|*
      Rental: *|RENTAL:NAME|*
      Start Date: *|TASK:START_DATE_TIME|*
      Due Date: *|TASK:DUE_DATE_TIME|*
      *|TASK:VENDOR_TASK_URL|*
    `,
  },
  [AutomationEventTypes.TaskCompleted]: {
    subject: 'Task *|TASK:NAME|* for *|RENTAL:NAME|* is Completed',
    message: `
      Hi Team,

      The task you created has been marked as completed. Please see the details below:

      Task Name: *|TASK:NAME|*
      Rental: *|RENTAL:NAME|*
      Start Date: *|TASK:START_DATE_TIME|*
      Due Date: *|TASK:DUE_DATE_TIME|*
      *|TASK:VENDOR_TASK_URL|*
    `,
  },
  [AutomationEventTypes.TaskOverdue]: {
    subject: 'Task *|TASK:NAME|* for *|RENTAL:NAME|* is Overdue',
    message: `
      Hi Team,

      This is a friendly reminder that the task assigned to you has not been marked as completed yet. Please take the necessary actions and update the status to Completed. Below are the details:

      Task Name: *|TASK:NAME|*
      Rental: *|RENTAL:NAME|*
      Start Date: *|TASK:START_DATE_TIME|*
      Due Date: *|TASK:DUE_DATE_TIME|*
      *|TASK:VENDOR_TASK_URL|*
    `,
  },
  [AutomationEventTypes.TaskReassigned]: {
    subject: 'Task *|TASK:NAME|* for *|RENTAL:NAME|* is assigned to you.',
    message: `
      Hi Team,

      A new task has been assigned to you. Please find the details below:

      Task Name: *|TASK:NAME|*
      Rental: *|RENTAL:NAME|*
      Start Date: *|TASK:START_DATE_TIME|*
      Due Date: *|TASK:DUE_DATE_TIME|*
      *|TASK:VENDOR_TASK_URL|*
    `,
  },
  [AutomationEventTypes.TaskReassigned + '-old']: {
    subject: 'Task *|TASK:NAME|* for *|RENTAL:NAME|* is no more assigned to you',
    message: `
      Hi Team,

    A task that was previously assigned to you has now been reassigned. Please find the details below:

    Task Name: *|TASK:NAME|*
    Rental: *|RENTAL:NAME|*
    Start Date: *|TASK:START_DATE_TIME|*
    Due Date: *|TASK:DUE_DATE_TIME|*
    `,
  },
}
